import axios from "axios";
import { getData } from "../contexts/authContext";

export const deleteTeam = async (teamId: string) => {
  const token = await getData("idToken");
  const url = `${process.env.REACT_APP_BASE_URL}/team/${teamId}`;

  const { data } = await axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const updateTeam = async (teamId: string, teamName: string) => {
  const token = await getData("idToken");
  const url = `${process.env.REACT_APP_BASE_URL}/team/${teamId}`;

  const { data } = await axios.patch(
    url,
    { name: teamName },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getCoachTeams = async (
  clinicianId: string,
  searchValue?: string
) => {
  const token = await getData("idToken");
  let url = `${process.env.REACT_APP_BASE_URL}/team/coach/${clinicianId}`;

  if (searchValue) {
    url = `${url}?name=${searchValue}`;
  }

  const { data } = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const createNewTeam = async (clinicianId: string, name: string) => {
  const token = await getData("idToken");
  const url = `${process.env.REACT_APP_BASE_URL}/team`;

  const { data } = await axios.post(
    url,
    { clinicianId, name },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getTeamsString = (athleteTeams: string[], teams: any[]) => {
  // Filter teams array to get only the teams that the athlete belongs to
  const athleteTeamNames = teams
    .filter((team) => athleteTeams?.includes(team._id))
    .map((team) => team.name);

  // Join the team names with commas
  return athleteTeamNames.join(", ");
};
